export const resetpassword = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        resetpassword:'Reset password',
        submit:'Submit',
        loading:'Loading...',
        newPassword: 'New Password',
        confirmPassword: 'Confirm Password',
        changePassword:"Change Password",
        changePasswordMsg:"You do not update password from 2 month you need to update your password.Please Update Your Password"
    },

	ar: {
        resetpassword:'إعادة تعيين كلمة المرور',
        submit:'إرسال',
        loading:'جار التحميل…',
        newPassword: 'كلمة السر الجديدة',
        confirmPassword: 'تأكيد كلمة المرور',
        changePassword:"تغيير كلمة المرور",
        changePasswordMsg:"لا تقم بتحديث كلمة المرور من شهرين ، فأنت بحاجة إلى تحديث كلمة المرور الخاصة بك. يرجى تحديث كلمة المرور الخاصة بك"

    }
}